import { Input } from "@Tmp/Fields";
import axios from "axios";
import * as React from "react";
import { useState } from "react";
import { Button } from "..";
import { PromotionCodeProps } from "./PromotionCode.types";

function PromotionCode({
    Input: InputProps,
    Button: { onClick: ButtonOnClick, ...ButtonProps } = {},
    invalidMessage = "Ugyldig kampagnekode",
    alreadyActiveMessage = "Kampangekoden er allerede aktiv",
    ...props
}: PromotionCodeProps) {
    const [loading, setLoading] = useState(false);
    const [promotionCode, setPromotionCode] = useState("");
    const [promotionCodeError, setPromotionCodeError] = useState<
        "already_active" | "invalid" | undefined
    >();

    const handleSubmit = () => {
        setPromotionCodeError(undefined);
        setLoading(true);

        axios
            .post("/wp-content/plugins/tmp/api/promotionCode.php", { code: promotionCode })
            .then((response) => {
                if (response.status === 200) {
                    tmp.cart.load();
                    setPromotionCode("");
                }
            })
            .catch((error) => {
                if (error.response.data?.status === "already_active") {
                    setPromotionCodeError("already_active");
                    return;
                }
                setPromotionCodeError("invalid");
            })
            .finally(() => setLoading(false));
    };

    const handleButtonClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        ButtonOnClick?.(e);
        handleSubmit();
    };

    const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setPromotionCodeError(undefined);
        setPromotionCode(e.target.value);
    };

    const getErrorMessage = () => {
        switch (promotionCodeError) {
            case "already_active":
                return alreadyActiveMessage;

            case "invalid":
                return invalidMessage;
        }

        return undefined;
    };

    return (
        <div className="tmp-promotion-code__container">
            <Input
                value={promotionCode}
                onChange={handleInputChange}
                action={handleSubmit}
                placeholder="Indtast kampagnekode"
                errorMessage={getErrorMessage()}
                iconAfter={loading ? "fas fa-spinner fa-spin" : undefined}
                {...InputProps}
            />
            <Button onClick={handleButtonClick} {...ButtonProps}>
                Anvend
            </Button>
        </div>
    );
}

export default PromotionCode;
